function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clone from 'ramda/src/clone';
import concat from 'ramda/src/concat';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';
import uniq from 'ramda/src/uniq';
import { stateGo } from 'redux-ui-router';
import i18n from 'invision-core/src/components/i18n/i18n';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { fetchCoolingPeriod, fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { IsOfferFeatureEnabled, MetadataCodeLoadedSelector, MetadataCodeTypeIntegerSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { OFFER_STATUS_INDICATOR_STATUS } from 'invision-core/src/constants/status.constants';
import { retrieveOfferingsMetadata } from 'invision-core/src/components/metadata/offerings/offerings.actions';
import CustomerCareKeys from '../../../../../locales/keys';
import { filterBulkOfferOptions, getOptionsByActiveBriType, hasPendingChange, offerOptionsStatus } from './offering.component.helper';
import { BILLER_RULE_INSTANCE_TYPE, BILLER_RULE_INSTANCE_TYPE_COMBINATIONS } from '../../../../../customercare.constants';
import { PRODUCT_CLASSIFICATIONS } from 'invision-core/src/constants/product.constants';
import { STATE_OR_NAME as ADD_OFFER_STATE } from '../../../../../reducers/constants/add.offer.wizard.constants';
import { RECONNECT_OFFER_STATE_NAME, STATE_OR_NAME as EDIT_OFFER_STATE } from '../../../../../reducers/constants/edit.offer.wizard.constants';
import { STATE_NAME as TRANSITION_OFFER_STATE } from '../../../orders/transition/transition.offer.wizard.constants';
import { SUBSCRIPTION_DETAILS_ROUTE } from '../../../subscriptions/subscriptions.config';
import { OFFER_DETAIL_ROUTE } from '../../../offers/offers.config';
import { CUSTOMER_REMOVE_OFFER_URL } from '../../../offers/remove/remove.offer.config';
import { IsCurrentAccountPostpaidSelector, IsFetchingAccountDetailsSelector } from '../../../../../reducers/selectors/customer.convergent.biller.selectors';
import { beginEditOfferOrder, setSelectedOfferName, startEditOfferFlow } from '../../../../../reducers/actions/offering.order.actions';
import { SubmittedOrderErrorSelector } from '../../../../../reducers/selectors/selected.offering.order.selectors';
import { setCurrentSubscriptionOfferingDetails } from '../../../../../reducers/actions/customer.subscriptions.actions';
import { DISCONNECT_OFFERS_DBSS_ROUTE } from '../../../offers/disconnect/dbss/disconnect.offers.dbss.config';
import { DISCONNECT_OFFERS_ITV_ROUTE } from '../../../offers/disconnect/itv/disconnect.offers.itv.config';
import { ChangeOfferEligibilityRulesSelector, IsCoolingPeriodEnabledSelector } from '../../../../../reducers/selectors/customer.offerings.selectors';
import { OFFERING_OPTION_STATUSES } from '../../../../shared/constants/offering.option.status.constants';
import { offerIsEligible } from '../../../../../reducers/selectors/dashboard.selectors.helper';
import { IsInGracePeriodSelector } from '../../../../../reducers/selectors/dashboard.selectors';
import { PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesViewModelSelector } from '../../../../../reducers/selectors/customer.ewallet.selectors';
import { renewOffCycleCharges, retrieveWallet, updateOfferingInstancePaymentInstrument } from '../../../../../reducers/actions/customer.ewallet.actions';
import { retrieveConvergentBillerAccountDetails, retrieveConvergentBillerSubscriberSummary } from '../../../../../reducers/actions/customer.convergent.biller.actions';
import { fetchSubscriberProductServiceRelationships, updateSubscriberProductServiceRelationships } from '../../../../../reducers/actions/product.service.relationships.actions';
import { ProductServiceRelationshipsSelector } from '../../../../../reducers/selectors/product.service.relationships.selectors';
import { BLANK_PAYMENT_INSTRUMENT } from '../../../makePayment/make.payment.constants';
import { CurrentCustomerIdSelector } from '../../../../../reducers/selectors/customer.selectors';
import { getOrderIdAndSubscriberProductIds } from '../../../../../reducers/helpers/off.cycle.helpers';
import { MENU_ITEMS } from '../dashboard.constants';
export var OfferingController = /*#__PURE__*/function () {
  function OfferingController($state, $ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, OfferingController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $state: $state,
      $timeout: $timeout,
      CustomerCareKeys: CustomerCareKeys,
      isEditingPaymentInstrument: false,
      isExpanded: false,
      isModifyPaymentMethodPopupShown: false,
      modalPaymentMethod: {},
      onCloseProductServiceRelationshipsModal: this.onCloseProductServiceRelationshipsModal.bind(this),
      onMoreItemSelected: this.onMoreItemSelected.bind(this),
      onSubmitProductServiceRelationshipsModal: this.onSubmitProductServiceRelationshipsModal.bind(this),
      toolTipTemplate: require('./cooling.period.template.html'),
      translatedError: null,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(OfferingController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.bulkOffer = this.filterBulkOffer(this.offer);
      this.isExpanded = this.isExpandedByDefault;
      if (this.offer.PaymentInstrument) {
        this.paymentFailedOrRetryTooltip = this.offer.PaymentInstrument.Flagged ? i18n.translate(this.CustomerCareKeys.CUSTOMER_DASHBOARD.PAYMENT_RETRY_DISABLED_TOOLTIP) : i18n.translate(this.CustomerCareKeys.CUSTOMER_DASHBOARD.PAYMENT_FAILURE);
      }
      this.connectRedux();
      this.contractTermsConditionsPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.contractTermsConditionsPopupApi = event.api;
        }
      };
      this.productServiceRelationshipsModalConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.productServiceRelationshipsModalApi = event.api;
        }
      };
      this.openContractTermsConditionsPopup = function () {
        _this.contractTermsConditionsPopupOpened = true;
        _this.$timeout(function () {
          _this.contractTermsConditionsPopupApi.open();
        });
      };
      this.handleCloseContractTermsConditionsPopup = function () {
        _this.contractTermsConditionsPopupApi.close();
        _this.contractTermsConditionsPopupOpened = false;
      };
      this.changePaymentPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.changePaymentPopupApi = event.api;
        }
      };
      this.openChangePaymentMethodPopup = function () {
        _this.actions.retrieveWallet({
          customerId: _this.customerId
        }).then(function () {
          _this.showChangePaymentPopup = true;
          _this.$timeout(function () {
            _this.changePaymentPopupApi.open();
          });
        });
      };
      this.closeChangePaymentMethodPopup = function () {
        _this.changePaymentPopupApi.close();
        _this.showChangePaymentPopup = false;
      };
      this.onChangePaymentMethod = function (paymentInstrument) {
        var paymentInstrumentId = paymentInstrument.Default ? null : paymentInstrument.Id;
        _this.actions.updateOfferingInstancePaymentInstrument(_this.customerId, _this.offer.OfferingInstanceId, paymentInstrumentId).then(function () {
          _this.refreshServices && _this.refreshServices();
          _this.actions.retrieveConvergentBillerSubscriberSummary(_this.customerId, true);
          _this.uiNotificationService.success(i18n.translate(_this.CustomerCareKeys.MAKE_PAYMENT.EDIT_INSTRUMENT_SUCCESS));
        }).catch(function (error) {
          _this.uiNotificationService.transientError(error.translatedMessage);
        }).finally(function () {
          _this.closeChangePaymentMethodPopup();
        });
      };
      this.modifyPaymentMethodPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.modifyPaymentMethodPopupApi = event.api;
        }
      };
      this.openPaymentMethodPopup = function () {
        var isEdit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        _this.isEditingPaymentInstrument = isEdit;
        _this.modalPaymentMethod = clone(isEdit ? _this.offer.PaymentInstrument : BLANK_PAYMENT_INSTRUMENT);
        _this.isModifyPaymentMethodPopupShown = true;
        _this.$timeout(function () {
          _this.modifyPaymentMethodPopupApi.open();
        });
      };
      this.onCloseModifyPaymentMethodPopup = function () {
        _this.modifyPaymentMethodPopupApi.close();
        _this.isModifyPaymentMethodPopupShown = false;
      };
      this.onSuccessModifyPaymentMethodPopup = function () {
        _this.refreshServices && _this.refreshServices();
        _this.actions.retrieveConvergentBillerSubscriberSummary(_this.customerId, true).catch(function (error) {
          _this.uiNotificationService.transientError(error.translatedMessage);
        }).finally(function () {
          _this.onCloseModifyPaymentMethodPopup();
        });
      };
      this.fetchCodeTypes().then(function () {
        if (_this.offer.IsCoolingOff && _this.state.isCoolingPeriodEnabledForBU) {
          _this.isCoolingOffEnabled = true;
          _this.tooltipContext = {
            title: i18n.translate(CustomerCareKeys.CUSTOMER_DASHBOARD.DEVICE_FINANCING_COOLING_PERIOD)
          };
        } else {
          _this.isCoolingOffEnabled = false;
        }
      });
    }
  }, {
    key: "fetchCodeTypes",
    value: function fetchCodeTypes() {
      var promises = [];
      if (!this.state.transitionConfigurationLoaded) {
        promises.push(this.actions.fetchCodeType(CODES.TransitionConfiguration));
      }
      if (!this.state.coolingPeriodLoaded) {
        promises.push(this.actions.fetchCodeType(CODES.CoolingPeriod));
      }
      if (!this.state.serviceAttributesLoaded) {
        promises.push(this.actions.fetchCodeType(CODES.ServiceAttribute));
      }
      return Promise.all(promises);
    }
  }, {
    key: "$onChanges",
    value: function $onChanges() {
      var briOptions = getOptionsByActiveBriType(this.offer, PRODUCT_CLASSIFICATIONS.PRODUCT);
      this.sortedOneTimeOptions = this.sortOfferOptionsByBillerTypeTotal(briOptions[BILLER_RULE_INSTANCE_TYPE.ONETIME], BILLER_RULE_INSTANCE_TYPE.ONETIME);
      this.sortedRecurringOptions = this.sortOfferOptionsByBillerTypeTotal(briOptions[BILLER_RULE_INSTANCE_TYPE.RECURRING], BILLER_RULE_INSTANCE_TYPE.RECURRING);
      this.sortedSubscriptionOptions = this.sortOfferOptionsByBillerTypeTotal(briOptions[BILLER_RULE_INSTANCE_TYPE.SUBSCRIPTION], BILLER_RULE_INSTANCE_TYPE.SUBSCRIPTION);
      this.usageOnlyOptions = briOptions[BILLER_RULE_INSTANCE_TYPE_COMBINATIONS.STANDALONE_USAGE];
      this.hasOneTimeOptions = this.sortedOneTimeOptions.length > 0;
      this.hasRecurringOptions = this.sortedRecurringOptions.length > 0;
      this.hasSubscriptionOptions = this.sortedSubscriptionOptions.length > 0;
      this.hasUsageOnlyOptions = this.usageOnlyOptions.length > 0;
      this.hasPendingChange = hasPendingChange(this.offer);
      this.offerOptionsStatus = offerOptionsStatus(this.offer);
      this.hasSomeSuspendedOptions = this.offer.Options.some(function (option) {
        return option.Status === OFFERING_OPTION_STATUSES.SUSPENDED;
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnect();
    }
  }, {
    key: "connectRedux",
    value: function connectRedux() {
      var _this2 = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          BusinessUnitIsDbss: IsDbss(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          changeOfferEligibilityRules: ChangeOfferEligibilityRulesSelector(store),
          coolingPeriodLoaded: MetadataCodeLoadedSelector(CODES.CoolingPeriod, store),
          isCoolingPeriodEnabledForBU: IsCoolingPeriodEnabledSelector(store),
          isCurrentAccountPostpaid: IsCurrentAccountPostpaidSelector(store),
          isFetchingAccountDetails: IsFetchingAccountDetailsSelector(store),
          isInGracePeriod: IsInGracePeriodSelector(store),
          isItvOffersEnabled: IsOfferFeatureEnabled(store),
          lastAttemptError: SubmittedOrderErrorSelector(store),
          paymentInstruments: PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesViewModelSelector(store),
          productServiceRelationships: ProductServiceRelationshipsSelector(store),
          serviceAttributesLoaded: MetadataCodeLoadedSelector(CODES.ServiceAttribute, store),
          transitionConfiguration: MetadataCodeTypeIntegerSelector(CODES.TransitionConfiguration, store),
          transitionConfigurationLoaded: MetadataCodeLoadedSelector(CODES.TransitionConfiguration, store)
        };
      };
      var controllerActions = {
        beginEditOfferOrder: beginEditOfferOrder,
        fetchCodeType: fetchCodeTypes,
        fetchCoolingPeriod: fetchCoolingPeriod,
        fetchSubscriberProductServiceRelationships: fetchSubscriberProductServiceRelationships,
        renewOffCycleCharges: renewOffCycleCharges,
        retrieveConvergentBillerAccountDetails: retrieveConvergentBillerAccountDetails,
        retrieveConvergentBillerSubscriberSummary: retrieveConvergentBillerSubscriberSummary,
        retrieveOfferingsMetadata: retrieveOfferingsMetadata,
        retrieveWallet: retrieveWallet,
        setCurrentSubscriptionOfferingDetails: setCurrentSubscriptionOfferingDetails,
        setSelectedOfferName: setSelectedOfferName,
        startEditOfferFlow: startEditOfferFlow,
        stateGo: stateGo,
        updateOfferingInstancePaymentInstrument: updateOfferingInstancePaymentInstrument,
        updateSubscriberProductServiceRelationships: updateSubscriberProductServiceRelationships
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
    }
  }, {
    key: "onMoreItemSelected",
    value: function onMoreItemSelected(option) {
      var _this3 = this;
      switch (option.id) {
        case MENU_ITEMS.ADD_ANOTHER_OFFER:
          this.$state.go(ADD_OFFER_STATE, {
            customerId: this.customerId
          });
          break;
        case MENU_ITEMS.RECONNECT_OFFER:
          this.actions.stateGo(RECONNECT_OFFER_STATE_NAME, {
            offeringId: this.offer.OfferingId,
            offeringInstanceId: this.offer.OfferingInstanceId,
            contractId: this.offer.OrderContractInstance ? this.offer.OrderContractInstance.OrderContractId : null,
            contractInstanceId: this.offer.OrderContractInstance ? this.offer.OrderContractInstance.Id : null
          });
          break;
        case MENU_ITEMS.DISCONNECT_OFFER:
          if (this.state.BusinessUnitIsDbss) {
            this.actions.stateGo(DISCONNECT_OFFERS_DBSS_ROUTE, {
              offeringId: this.offer.OfferingId,
              offeringInstanceId: this.offer.OfferingInstanceId
            });
          } else {
            this.actions.stateGo(DISCONNECT_OFFERS_ITV_ROUTE);
          }
          break;
        case MENU_ITEMS.REMOVE_OFFER:
          this.$state.go(CUSTOMER_REMOVE_OFFER_URL, {
            offeringId: this.offer.OfferingId,
            offeringInstanceId: this.offer.OfferingInstanceId,
            subscriptionId: this.offer.Subscription.Id,
            currency: this.currencyCode
          });
          break;
        case MENU_ITEMS.EDIT_OFFER:
          if (!this.hasSomeSuspendedOptions) {
            this.actions.startEditOfferFlow(this.offer.DisplayName);
            this.$state.go(EDIT_OFFER_STATE, {
              offeringId: this.offer.OfferingId,
              offeringInstanceId: this.offer.OfferingInstanceId,
              contractId: this.offer.OrderContractInstance ? this.offer.OrderContractInstance.OrderContractId : null,
              contractInstanceId: this.offer.OrderContractInstance ? this.offer.OrderContractInstance.Id : null
            });
          }
          break;
        case MENU_ITEMS.CHANGE_OFFER:
          {
            var currentOfferEligibilityRules = this.state.changeOfferEligibilityRules.find(function (changeOffer) {
              return changeOffer.OfferingInstanceId === _this3.offer.OfferingInstanceId;
            });
            var isEligible = offerIsEligible(this.offer, currentOfferEligibilityRules);
            if (isEligible && !this.hasSomeSuspendedOptions) {
              this.actions.setSelectedOfferName(this.offer.DisplayName);
              this.$state.go(TRANSITION_OFFER_STATE, {
                offeringId: this.offer.OfferingId,
                offeringInstanceId: this.offer.OfferingInstanceId
              });
            }
            break;
          }
        case MENU_ITEMS.RETRY_PAYMENT:
          {
            var offCycleFailures = getOrderIdAndSubscriberProductIds(this.offer);
            this.actions.renewOffCycleCharges(this.state.currentCustomerId, offCycleFailures.subscriberProductIds, offCycleFailures.orderId).then(function () {
              _this3.refreshServices && _this3.refreshServices();
              _this3.actions.retrieveConvergentBillerAccountDetails(_this3.customerId);
              if (!_this3.state.isInGracePeriod) {
                _this3.uiNotificationService.success(i18n.translate(_this3.CustomerCareKeys.MAKE_PAYMENT.PAYMENT_SUCCESSFUL));
              }
            }).catch(function (error) {
              _this3.uiNotificationService.transientError(error.translatedMessage);
            });
            break;
          }
        case MENU_ITEMS.ADD_PAYMENT_INSTRUMENT:
          this.openPaymentMethodPopup(false);
          break;
        case MENU_ITEMS.EDIT_PAYMENT_INSTRUMENT:
          this.openPaymentMethodPopup(true);
          break;
        case MENU_ITEMS.CHANGE_PAYMENT_INSTRUMENT:
          this.openChangePaymentMethodPopup();
          break;
        case MENU_ITEMS.MANAGE_PLAN_SERVICES:
          this.openProductServiceRelationshipsModal();
          break;
        default:
          break;
      }
    }
  }, {
    key: "offerIsActive",
    value: function offerIsActive() {
      return OFFER_STATUS_INDICATOR_STATUS.ACTIVE === this.offer.Status && !this.hasPendingChange;
    }
  }, {
    key: "showOfferStatus",
    get: function get() {
      //If this is an ItvOffer use the Offer widget, if not use the DBSS logic
      return this.state.isItvOffersEnabled ? this.state.isItvOffersEnabled : !this.hasSubscriptionOptions;
    }
  }, {
    key: "isPaymentFailedShown",
    value: function isPaymentFailedShown() {
      return this.offerIsActive() && this.offer.Options && this.offer.Options.some(function (option) {
        return option.OffCycleDetail && option.OffCycleDetail.GracePeriodExpiryDate && option.OffCycleDetail.CurrentRenewalFailedAttempts;
      });
    }
  }, {
    key: "handleExpansion",
    value: function handleExpansion() {
      this.isExpanded = !this.isExpanded;
    }
  }, {
    key: "launchOptionQuickEdit",
    value: function launchOptionQuickEdit() {
      this.actions.startEditOfferFlow(this.offer.Name);
      this.$state.go(EDIT_OFFER_STATE, {
        offeringId: this.offer.OfferingId,
        offeringInstanceId: this.offer.OfferingInstanceId,
        contractInstanceId: this.offer.OrderContractInstance ? this.offer.OrderContractInstance.Id : null,
        contractId: this.offer.OrderContractInstance ? this.offer.OrderContractInstance.OrderContractId : null
      });
    }
  }, {
    key: "showPendingStatusMessage",
    value: function showPendingStatusMessage() {
      return !this.hasSubscriptionOptions && this.offer.Status === OFFER_STATUS_INDICATOR_STATUS.PENDING_ACTIVE && (!(this.hasOneTimeOptions || this.hasRecurringOptions || this.hasUsageOnlyOptions) || !this.currencyCode);
    }
  }, {
    key: "sortOfferOptionsByBillerTypeTotal",
    value: function sortOfferOptionsByBillerTypeTotal(optionsToBeSorted, billerType) {
      return optionsToBeSorted.sort(function (a, b) {
        var firstItem = find(propEq(billerType, 'Type'))(concat(a.BillerRulePrices || [], a.BillerTypeAmounts || []));
        var secondItem = find(propEq(billerType, 'Type'))(concat(b.BillerRulePrices || [], b.BillerTypeAmounts || []));
        return firstItem && secondItem ? secondItem.TotalAmount - firstItem.TotalAmount : true;
      });
    }
  }, {
    key: "filterBulkOffer",
    value: function filterBulkOffer(offer) {
      return filterBulkOfferOptions(offer);
    }
  }, {
    key: "viewSubscriptionDetails",
    value: function viewSubscriptionDetails() {
      this.actions.setCurrentSubscriptionOfferingDetails(this.offer);
      if (this.offer.OfferStatus === OFFER_STATUS_INDICATOR_STATUS.PENDING_ACTIVE) {
        this.actions.stateGo(OFFER_DETAIL_ROUTE, {
          offerId: this.offer.OfferingId
        });
      } else {
        this.actions.stateGo(SUBSCRIPTION_DETAILS_ROUTE, {
          subscriptionId: this.offer.Subscription.Id
        });
      }
    }
  }, {
    key: "openProductServiceRelationshipsModal",
    value: function openProductServiceRelationshipsModal() {
      var _this4 = this;
      this.actions.fetchSubscriberProductServiceRelationships(this.state.currentCustomerId).then(function () {
        var allOfferingIds = [];
        (_this4.state.productServiceRelationships || []).forEach(function (services) {
          allOfferingIds.push(services.OfferingId.Value);
          (services.LinkableProviderPlans || []).forEach(function (providerPlans) {
            allOfferingIds.push(providerPlans.OfferingId.Value);
          });
        });
        _this4.actions.retrieveOfferingsMetadata(uniq(allOfferingIds)).then(function () {
          _this4.offeringMetadataLoaded = true;
        }).catch(function (error) {
          _this4.uiNotificationService.transientError(error.translatedMessage);
        });
        _this4.isProductServiceRelationshipsModalShown = true;
        _this4.$timeout(function () {
          _this4.productServiceRelationshipsModalApi.open();
        });
      }).catch(function (error) {
        _this4.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "onSubmitProductServiceRelationshipsModal",
    value: function onSubmitProductServiceRelationshipsModal(productServiceRelationships) {
      var _this5 = this;
      this.actions.updateSubscriberProductServiceRelationships(this.state.currentCustomerId, productServiceRelationships).then(function () {
        _this5.onCloseProductServiceRelationshipsModal();
        if (_this5.subscriberOfferComponentDisplayed) {
          _this5.refreshOfferDetails && _this5.refreshOfferDetails();
        }
        _this5.refreshServices && _this5.refreshServices();
        _this5.refreshConvergentBillerDetails && _this5.refreshConvergentBillerDetails();
        _this5.uiNotificationService.success(i18n.translate(_this5.CustomerCareKeys.PRODUCT_SERVICE_RELATIONSHIP.SUCCESS));
      }).catch(function (error) {
        _this5.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "onCloseProductServiceRelationshipsModal",
    value: function onCloseProductServiceRelationshipsModal() {
      this.productServiceRelationshipsModalApi.close();
      this.isProductServiceRelationshipsModalShown = false;
    }
  }]);
}();
export default {
  template: require('./offering.deprecated.html'),
  bindings: {
    currencyCode: '<',
    customerId: '<',
    hasAdminAccess: '<',
    isExpandedByDefault: '<',
    offer: '<',
    refreshOfferDetails: '&?',
    refreshServices: '&?',
    refreshConvergentBillerDetails: '&?',
    subscriberOfferComponentDisplayed: '<?'
  },
  controller: OfferingController,
  controllerAs: 'Offering'
};